import { Component, OnInit } from '@angular/core';
import { Title, Meta } from "@angular/platform-browser";

import { ApiClientsService, ApiClient } from "../../services/api-clients/api-clients.service";

let $_: any;

@Component({
    selector: 'app-agencies',
    templateUrl: './agencies.component.html',
    styleUrls: ['./agencies.component.css']
})
export class AgenciesComponent implements OnInit {

    db_read_complete: boolean = false;
    show_child_agencies = {};
    api_clients: ApiClient[] = [];

    constructor(private title_service: Title, private meta_service: Meta, private api_clients_service: ApiClientsService) {
        
        $_ = this;
        $_.title_service.setTitle('Sinirj 911 Live | List of Agencies');
    }

    ngOnInit() {

        $_.api_clients = $_.api_clients_service.get_api_clients('', (api_clients) => {
            
            $_.api_clients = api_clients;
            $_.db_read_complete = true;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/agencies/agencies.component.ts